// import components
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

// import hooks
import { useGetColumnDefs } from '../hooks/useGetColumnDefs';

// import queries
import { queries } from 'RestAPIs/rapini';

const ExecutedActions = () => {
  const columns = useGetColumnDefs();
  const { data, isLoading } = queries.useSecureAdminProceduresServicedeskRuns();

  return (
    <TableCRUDLayout
      getRowId={(row) => row.runId as number}
      columns={columns}
      rows={data?.runs ?? []}
      loading={isLoading}
      editable={false}
      hideCreateAction
    />
  );
};

export default ExecutedActions;
